.container {
  border-radius: var(--border-radius-sm);
  color: var(--color-neutral-60);
  font-size: smaller;
  font-weight: var(--font-weight-medium);
  height: 36px;
  padding-right: 6px;
  padding-left: 6px;
}

.containerHigh {
  background-color: #ffeaea;
}

.containerMedium {
  background-color: #fcecc5;
}

.containerLow {
  background-color: #e1fce9;
}

.containerInactive {
  background-color: #F5F5F5;
  color: var(--color-neutral-400);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9jb21wb25lbnRzL2ludGVybmFsL1Jpc2tMb3NpbmdEYXkiLCJzb3VyY2VzIjpbIlJpc2tMb3NpbmdEYXkubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRhaW5lciB7XG4gIGJvcmRlci1yYWRpdXM6IHZhcigtLWJvcmRlci1yYWRpdXMtc20pO1xuICBjb2xvcjogdmFyKC0tY29sb3ItbmV1dHJhbC02MCk7XG4gIGZvbnQtc2l6ZTogc21hbGxlcjtcbiAgZm9udC13ZWlnaHQ6IHZhcigtLWZvbnQtd2VpZ2h0LW1lZGl1bSk7XG4gIGhlaWdodDogMzZweDtcbiAgcGFkZGluZy1yaWdodDogNnB4O1xuICBwYWRkaW5nLWxlZnQ6IDZweDtcbn1cblxuLmNvbnRhaW5lckhpZ2gge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZlYWVhO1xufVxuXG4uY29udGFpbmVyTWVkaXVtIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZjZWNjNTtcbn1cblxuLmNvbnRhaW5lckxvdyB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNlMWZjZTk7XG59XG5cbi5jb250YWluZXJJbmFjdGl2ZSB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNGNUY1RjU7XG4gIGNvbG9yOiB2YXIoLS1jb2xvci1uZXV0cmFsLTQwMCk7XG59Il19 */